module.exports = __webpack_public_path__ + "img/weixin.e53e11d0.png";